import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';

const CoBrandTableProgram = ({
    cobrands,
    setSelectedCoBrand,
    loading,
    editOnClick,
    previewOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.cobrandId} />
            ),
        },
        {
            name: 'CoBrandID',
            fieldName: 'cobrandId',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'CoBrand',
            fieldName: 'name',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'On/Off Default',
            fieldName: 'onOffDefault',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            name: 'International On/Off',
            fieldName: 'internationalOn',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = cobrands ?? [];

    const selectionHook = (items) => {
        setSelectedCoBrand(items && items[0] && items[0].cobrandId);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={'cobrandId'}
            style={{
                position: 'relative',
                height: '80vh',
                width: '80vw',
            }}
        />
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CoBrandTableProgram;
